export default __webpack_public_path__ + "02cb541.png";